// data/plans.js
export const selfActivePlans = {
  headers: ["Leistung", "Beschreibung", "Kosten pro Episode"],
  sections: [
    {
      id: "audioVideo",
      title: "Audio & Video",
      features: [
        {
          id: "adService",
          name: "Audio & Video Ad-Service (Werbung)",
          description:
            "Schnitt & Produktion von Werbeinhalten (Native oder als Audiospots produziert) inkl. Sound-Design",
          values: ["", "", "25€"],
        },
        {
          id: "restoration",
          name: "Restauration von fertig geschnittenen Episoden",
          description:
            "Entfernen von starken Hall, Rauschen oder anderen Störfaktoren einer Episode",
          values: ["", "", "ab 60€"],
        },
        {
          id: "externalAudio",
          name: "Einbindung von externen Audioinhalten",
          description:
            "Einbindung kurzer Audioinhalte aus anderen Quellen wie bspw. Reportagen, Dokumentationen, Internetvideos oder Zitate",
          values: ["", "", "nach Absprache und Aufwand"],
        },
        {
          id: "socialTeaser",
          name: "Audio Teaser für Social Media",
          description:
            "Kurze, prägnante Auschnitte/Highlights aus einer Podcast-Episode für Social Media inkl. Sound-Design",
          values: ["", "", "ab 15€"],
        },
        {
          id: "motionDesign",
          name: "Motion Design/Graphics für Videopodcasts",
          description:
            "Einbindung grafischer Elemente (wie z.B Logo, Animationen oder Brand-Design) in Videopodcasts",
          values: ["", "", "ab 30€"],
        },
        {
          id: "blogPost",
          name: "Blogbeitrag zur Episode",
          description: "Erstellung eines Blogbeitrags zu einer Episode",
          values: ["", "", "ab 75€"],
        },
      ],
    },
    {
      id: "betreuungManagement",
      title: "Betreuung & Management",
      features: [
        {
          id: "microphoneService",
          name: "Mikrofon Versand & Service",
          description:
            "Professionelles Mikrofon-Kit – Lieferung inklusive Abwicklung",
          values: ["", "", "70€ pro Mikrofon"],
        },
        {
          id: "communityManagement",
          name: "Community Management für Spotify Kommentare",
          description:
            "Betreuung der Community-Kommunikation: Fragen, Feedback & Umfragen",
          values: ["", "", "nach Absprache und Aufwand"],
        },
        {
          id: "uploadHosting",
          name: "Uploadservice & Hosting",
          description:
            "Übernahme planmäßiger Veröffentlichungen und Hosting-Management",
          values: ["", "", "ab 15€"],
        },
        {
          id: "podigeeHosting",
          name: "Podigee Hosting Account",
          description:
            "Veröffentlichung über unseren Podigee Agentur Account - alle Features inklusive",
          values: ["", "", "ab 15€ / Monat"],
        },
      ],
    },
    {
      id: "socialAssetsCopywriting",
      title: "Social Assets & Copywriting",
      features: [
        {
          id: "videoReel",
          name: "Video-Reel",
          description:
            "Hochwertiges (9:16) Social-Media Highlight Video aus einer Episode (inkl. Captions, Animationen, Transitions)",
          values: ["", "", "ab 50€"],
        },
        {
          id: "motionReel",
          name: "Motion-Reel",
          description:
            "Hochwertiges (16:9) Social-Media Highlight Video, erstellt durch Animationen, Bilder, Motion Designs und mehr",
          values: ["", "", "ab 50€"],
        },
        {
          id: "socialMediaPost",
          name: "Social Media Beitrag",
          description: "Social-Media-Beitrag (4:5)",
          values: ["", "", "ab 40€"],
        },
        {
          id: "shownotesCreation",
          name: "Erstellung von Titel & Shownotes & Verlinkungen",
          description:
            "Erstellung von Shownotes (Titel, Untertitel, Beschreibungstexte, und Links zu einer Episode)",
          values: ["", "", "25€"],
        },
      ],
    },
  ],
};
